module.exports = __webpack_public_path__ + "static/media/informationBg.90e45d8c.png";